import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requireOnboarding = true }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream-50">
        <div className="text-charcoal-600 font-serif text-2xl italic">Styling your experience…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarding && !user.onboarding_completed) return <Navigate to="/onboarding" replace />;
  return children;
}
